import type * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Natives `<select>` im shadcn-Look. Bewusst kein Radix-Popover: Filter- und
 * Statusauswahl sind kurze Listen, und das native Element ist auf dem Handy
 * und mit Tastatur ohne Zutun korrekt (frontend-ux.md).
 */
export function Select({ className, ...props }: React.ComponentProps<'select'>) {
  return (
    <select
      className={cn(
        'flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
}
